var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internet-error"},[_c('div',{ref:"contentRef",staticClass:"content",class:{ 'breathing-animation': _vm.isBreathingAnimation }},[_c('h1',[_vm._v("Check Your Internet Connection")]),_c('p',[_vm._v("Please make sure you're connected to the internet and try again.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }